/** @format */

import { Injectable } from '@angular/core';

@Injectable() /* Need to include in providers array - each component that uses it should have its own instance */
export class IntersectionObservingService {
  private observer: IntersectionObserver | undefined;

  /**
   * @description Initializes the IntersactionObserver and starts observing
   *  			the provided element.
   * @param elementRef ElementRef of the element to be observed.
   * @param callback Function to be called when the element is intersecting the viewport.
   */
  initIntersectionObserver(
    element: HTMLElement,
    callback: () => void,
    options: IntersectionObserverInit = { threshold: 0.1 },
  ) {
    if (typeof IntersectionObserver === 'undefined') {
      return;
    }

    if (!element) {
      console.error('ElementRef is required for setting observer');
      return;
    }

    this.observer =
      this.observer ??
      new IntersectionObserver((entries) => {
        const intersectingEntries = entries.filter((entry) => entry.isIntersecting);

        intersectingEntries.forEach((entry) => {
          if (entry.isIntersecting) {
            callback();

            this.observer?.unobserve(entry.target);
          }
        });
      }, options);

    this.observer.observe(element);
  }

  /**
   * @description Disconnects the IntersactionObserver
   */
  disconnectObserver() {
    this.observer?.disconnect();
    this.observer = null;
  }
}
